import { useQuery } from "@tanstack/react-query";
import { getUserSessions } from "@/api/endpoints/formSessions";
import type { GetUserSessionsResponse } from "@/api/types/formSessions";
import { queryKeys } from "@/lib/queryClient";

export function useGetUserSessions(
  userId: string | undefined,
  options: { includeArchived?: boolean } = {}
) {
  const { includeArchived = false } = options;
  return useQuery<GetUserSessionsResponse, Error>({
    queryKey: [
      ...queryKeys.formSessions.byUser(userId!),
      { includeArchived },
    ] as const,
    queryFn: () => getUserSessions(userId!, { includeArchived }),
    enabled: !!userId,
  });
}
